import * as React from 'react'

import styled from '@emotion/styled'

import { spacing } from '../../../theme'
import Header, { HeaderVariants } from '../../Header/Header'
import PaddingInset from '../../layout/PaddingInset'

export type PageHeaderProps = {
  title: React.ReactNode
  subtext?: React.ReactNode
  titleVariant?: HeaderVariants
  titleElement?: React.ElementType
  children?: React.ReactNode
}

const Container = styled(PaddingInset)`
  display: grid;
  max-width: ${props => props.theme.maxWidths.content};
  row-gap: ${spacing.m};

  ${props => props.theme.typography.body};
`

const Subtext = styled.p`
  ${props => props.theme.typography.body};
  color: ${props => props.theme.colors.textSubtle};
  max-width: 30.5rem;
`

/**
 * @deprecated Use ArcadePageHeader instead
 */
const PageHeader: React.FC<PageHeaderProps> = ({ titleElement, titleVariant, subtext, title, children }) => (
  <Container>
    <Header variant={titleVariant ?? 'header'} as={titleElement ?? 'h1'} color="textStandard">
      {title}
    </Header>
    {subtext != null ? <Subtext>{subtext}</Subtext> : null}
    {children}
  </Container>
)

export default PageHeader
